export const actionTypes = {
  REQUEST_START: 'CONTACTS.MAKE_APPOINTMENT.GET_MANAGEMENTS.REQUEST_START',
  REQUEST_SUCCESS: 'CONTACTS.MAKE_APPOINTMENT.GET_MANAGEMENTS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'CONTACTS.MAKE_APPOINTMENT.GET_MANAGEMENTS.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
